<template>
  <div class="tabs">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleTabClick">
      <el-tab-pane :label="$t('RouterObj.ReceivableAccount')" name="ReceivableAccount" lazy>
        <div v-if="activeName === 'ReceivableAccount'">
          <ReceivableAccount ref="ReceivableAccount" />
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('RouterObj.CustomerAccount')" name="CustomerAccount" lazy>
        <div v-if="activeName === 'CustomerAccount'">
          <CustomerAccount ref="CustomerAccount" />
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('RouterObj.BranchAccounts')" name="BranchAccounts" lazy>
        <div v-if="activeName === 'BranchAccounts'">
          <BranchAccounts ref="BranchAccounts" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ReceivableAccount from './index.vue';
import CustomerAccount from '../customerAccount/index.vue';
import BranchAccounts from '../branchAccounts/index.vue';

export default {
  name: 'Tabs',
  components: {
    ReceivableAccount,
    CustomerAccount,
    BranchAccounts
  },
  data() {
    return {
      activeName: 'ReceivableAccount'
    };
  },
  methods: {
    handleTabClick(tab) {
      // 标签页切换时的回调
      this.$nextTick(() => {
        // 调用当前激活组件的特定方法
        const activeComponent = this.$refs[tab.name];
        if (activeComponent && typeof activeComponent.onTabActivated === 'function') {
          activeComponent.onTabActivated();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs--border-card>.el-tabs__content {
  padding: 0;
}
</style>
